function save(sess, unit) {
    const {Unit} = sess;
    return Unit.create(unit);
}

function remove(sess, id) {
    const {Unit} = sess;
    if (!Unit.idExists(id)) {
        throw new Error(`can not find unit with id '${id}'`);
    }
    const unitTarget = Unit.withId(id);
    switch (unitTarget.type) {
        case 'file':
            if (unitTarget.fileType) {
                unitTarget.fileType.delete();
            }
            break;
        case 'video':
            if (unitTarget.fileType) {
                unitTarget.fileType.delete();
            }
            break;
        default:
            break;
    }
    return unitTarget.delete();
}

function savePdfUnit(sess, pdfUnit, unitId) {
    const {PdfUnit, Unit} = sess;
    if (!Unit.idExists(unitId)) {
        throw new Error(`can not find unit with id '${unitId}'`);
    }
    return PdfUnit.create({
        ...pdfUnit,
        unit: unitId,
    });
}

function removePdfUnit(sess, id) {
    const {PdfUnit} = sess;
    if (!PdfUnit.idExists(id)) {
        throw new Error(`can not find pdf unit with id '${id}'`);
    }
    return PdfUnit.withId(id).delete();
}

function saveVideoUnit(sess, videoUnit, unitId) {
    const {VideoUnit, Unit} = sess;
    if (!Unit.idExists(unitId)) {
        throw new Error(`can not find unit with id '${unitId}'`);
    }
    return VideoUnit.create({
        ...videoUnit,
        unit: unitId,
    });
}

function removeVideoUnit(sess, id) {
    const {VideoUnit} = sess;
    if (!VideoUnit.idExists(id)) {
        throw new Error(`can not find video unit with id '${id}'`);
    }
    return VideoUnit.withId(id).delete();
}

function saveQuizUnit(sess, quizId, unitId) {
    const {QuizUnit, Unit, Quiz} = sess;
    if (!Unit.idExists(unitId)) {
        throw new Error(`can not find unit with id '${unitId}'`);
    }
    if (!Quiz.idExists(quizId)) {
        throw new Error(`can not find quiz with id '${quizId}'`);
    }
    const quizTarget = Quiz.withId(quizId)
    return QuizUnit.create({
        id: unitId,
        quiz: quizTarget,
        unit: unitId,
        startAt: new Date(),
    });
}

function removeQuizUnit(sess, id) {
    const {QuizUnit} = sess;
    if (!QuizUnit.idExists(id)) {
        throw new Error(`can not find video unit with id '${id}'`);
    }
    return QuizUnit.withId(id).delete();
}

function setSeenUnitFlag(sess, unitId, isSeenStatus) {
    const { Unit } = sess;
    if (!Unit.idExists(unitId)) {
        throw new Error(`can not find quiz unit with id '${unitId}'`);
    }
    Unit.withId(unitId).update({
        isSeen: isSeenStatus,
    });
}

export default {
    save,
    remove,
    savePdfUnit,
    saveVideoUnit,
    saveQuizUnit,
    removePdfUnit,
    removeVideoUnit,
    removeQuizUnit,
    setSeenUnitFlag
}